const pageHistory: any = {};

export default pageHistory;
